var exports = {
  "Lb": "XPostEmbed.module__xPost___ZU9qQk",
  "rT": "XPostEmbed.module__parts___ZU9qQk",
  "y_": "XPostEmbed.module__part___ZU9qQk",
  "TL": "XPostEmbed.module__quoted___ZU9qQk",
  "$_": "XPostEmbed.module__media___ZU9qQk",
};

module.exports = exports;
